/* eslint-disable @typescript-eslint/no-explicit-any -- disabled as we want to follow the codebase of MUI */
import type { GridFilterOperator } from '@mui/x-data-grid-pro';

import { GridFilterInputNumericRange } from '../../panel/filter-panel/grid-filter-input-numeric-range';

type GridNumericRangeOperator = GridFilterOperator<any, number[] | null, any>;

const isBetweenOperator = (
  min: number,
  max: number,
): GridNumericRangeOperator => ({
  label: 'is between',
  value: 'isBetween',
  getApplyFilterFn: (filterItem) => {
    if (!Array.isArray(filterItem.value) || filterItem.value.length !== 2) {
      return null;
    }
    if (filterItem.value[0] == null || filterItem.value[1] == null) {
      return null;
    }
    return (value): boolean => {
      return (
        value !== null &&
        filterItem.value[0] <= value &&
        value <= filterItem.value[1]
      );
    };
  },
  InputComponent: GridFilterInputNumericRange,
  InputComponentProps: {
    type: 'number',
    InputProps: { inputProps: { min, max } },
  },
});

export const getGridNumericRangeOperators = (
  min: number,
  max: number,
): GridNumericRangeOperator[] => [isBetweenOperator(min, max)];
